export default __webpack_public_path__ + "img/83f63306e065e43967069942109efc95.svg";